import { LoaderVariantType } from './variants';
export const getLoaderStyles = (FOUNDATIONS) => ({
    [LoaderVariantType.SECONDARY]: {
        container: {
            display: 'inline-block',
            height: FOUNDATIONS.size_300,
            width: FOUNDATIONS.size_300,
        },
        animation_loader: {
            border_width: FOUNDATIONS.border_150,
            primary_color: FOUNDATIONS.color_brand_bg_50,
            secondary_color: FOUNDATIONS.color_neutral_bg_onsurface_200,
        },
    },
    [LoaderVariantType.BUBBLE]: {
        container: {
            display: 'inline-block',
        },
        animation_button_loader: {
            color: FOUNDATIONS.color_exception_neutral_bg_1300,
        },
    },
});
//# sourceMappingURL=styles.js.map